// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner[data-v-74998449]{background-size:100% 100%;background-repeat:no-repeat;background-position:50%}.banner[data-v-74998449] .van-image{width:100%;height:100%;display:block;text-align:center}.banner .el-icon-picture-outline[data-v-74998449]{font-size:1.33333rem;color:#ccc}", ""]);
// Exports
module.exports = exports;
